export default {
  推荐66人: `友達66名を紹介して、バルセロナへの旅をゲットしよう`,
  成为EBC推荐官: "EBCの紹介者になり、豪華な旅を楽しもう",
  立即参与: "今すぐ参加",
  活动规则与要求: "参加ルールと条件",
  每一次推荐: "紹介人数クリアだけで、バルセロナへの旅が手に入ります",
  参与规则: "参加ルール",
  成为EBC推荐官并邀请66人: "EBCの紹介者になって、66人の友達を招待しよう",
  所有被邀请人均入金大于等于$500: `招待された方は、最低500ドル以上を入金し、取引を完了する必要があります。`,
  参与方法: "参加方法",
  立即推荐: "今すぐ紹介を始めよう",
  登录EBC用户中心: "EBCマイページにログイン",
  "进入“大赛推荐官”活动页面": "「取引大会紹介キャンペーン」をクリック",
  生成您的邀请链接或二维码: "専用紹介リンクまたはQRコードを取得",
  巴萨荣耀之旅: "チャンピオンに続く道、FCバルセロナへの旅",
  每笔订单都是攻守博弈的艺术: `すべての取引は攻守のバランス。あなたの決断が市場でのゴールに。誇りと栄光、そしてFCバルセロナへの旅が、EBC100万ドル取引大会の勝者をお待ちしています。`,
  活动时间: "紹介期間：",
  "2025年2月22日": "2025年2月22日01:00:00(MT4/MT5時間)ー2025年8月(MT4/MT5時間)",
  活动规则: "キャンペーンルール",
  ruleList: [
    "本キャンペーンは、通常の紹介報酬やその他キャンペーンとの併用ができます。",
    "被紹介者は、500ドル以上の入金と取引を完了する必要があります。また、第三者振替による送金は対象外です。",
    "参加ルールに違反などがあった場合、本特典の対象外とさせていただくことがあります。",
    "紹介リンクを通じて登録されたアカウントは、紹介者変更を申請することができません。",
    "66人以上の有効なアカウントを開設された紹介者が招待の対象となり、VIP観覧席チケット及び航空券と宿泊費が支給されます。",
    "EBC Financial Groupは、本イベントの最終的な解釈権を有します。",
  ],
};
